const account = {
  account: {
    hero: {
      myAccount: "મારું ખાતું",
      donorFallback: "દાતા",
      donateAgain: "ફરી દાન કરો",
      signOut: "સાઇન આઉટ",
    },
    noDonor: {
      title: "હજુ સુધી કોઈ દાતા પ્રોફાઇલ નથી",
      description:
        "તમારું પહેલું દાન કરો અને અમે તેને આપમેળે તમારા ખાતા સાથે જોડી દઈશું.",
      browseCauses: "કારણો જુઓ",
    },
    stats: {
      lifetimeTotal: "આજીવન કુલ",
      donations: "દાન",
      thisFy: "આ નાણાકીય વર્ષ",
      activeRecurring: "સક્રિય રિકરિંગ",
    },
    tabs: {
      donations: "દાન",
      recurring: "રિકરિંગ",
      statement: "80G સ્ટેટમેન્ટ",
      profile: "પ્રોફાઇલ",
    },
    statement: {
      title: "80G વાર્ષિક સ્ટેટમેન્ટ ડાઉનલોડ કરો",
      description:
        "પસંદ કરેલા નાણાકીય વર્ષ માટેના તમારા તમામ પાત્ર દાનનું એકીકૃત PDF.",
      financialYear: "નાણાકીય વર્ષ",
      noDonations: "હજુ સુધી કોઈ સફળ દાન નથી",
      fyOption: "નાણાકીય વર્ષ {{fy}}",
      download: "સ્ટેટમેન્ટ ડાઉનલોડ કરો",
    },
    toast: {
      signedOut: "સાઇન આઉટ થઈ ગયા",
      noStatementDonations: "આ નાણાકીય વર્ષમાં કોઈ 80G દાન નથી",
      subscriptionStatus: "સબ્સ્ક્રિપ્શન {{status}}",
      failed: "નિષ્ફળ",
      profileUpdated: "પ્રોફાઇલ અપડેટ થઈ",
    },
    donationsTable: {
      empty: "તમે હજુ સુધી કોઈ દાન કર્યું નથી.",
      makeFirst: "તમારું પહેલું દાન કરો",
      date: "તારીખ",
      receipt: "રસીદ",
      cause: "કારણ",
      mode: "પદ્ધતિ",
      amount: "રકમ",
      status: "સ્થિતિ",
      receiptAction: "રસીદ",
      download: "ડાઉનલોડ",
      pending: "બાકી",
    },
    recurringTable: {
      empty: "તમારી પાસે કોઈ રિકરિંગ દાન યોજના નથી.",
      frequency: "આવર્તન",
      amount: "રકમ",
      nextPayment: "આગામી ચુકવણી",
      started: "શરૂ થયું",
      status: "સ્થિતિ",
      actions: "ક્રિયાઓ",
      pause: "થોભો",
      resume: "ફરી શરૂ કરો",
      cancel: "રદ કરો",
    },
    profile: {
      title: "દાતા પ્રોફાઇલ",
      description:
        "દરેક રસીદ પર વપરાય છે — 80G પાત્રતા માટે કૃપા કરીને તમારો PAN અને સરનામું અપડેટ રાખો.",
      fullName: "પૂરું નામ *",
      mobile: "મોબાઇલ *",
      email: "ઈમેલ",
      pan: "PAN (80G માટે)",
      panPlaceholder: "ABCDE1234F",
      dateOfBirth: "જન્મ તારીખ",
      country: "દેશ",
      address: "સરનામું",
      city: "શહેર",
      state: "રાજ્ય",
      pincode: "પિનકોડ",
      save: "પ્રોફાઇલ સાચવો",
    },
  },
  applyAdmission: {
    eyebrow: "પ્રવેશ",
    title: "પ્રવેશ માટે અરજી કરો",
    subtitle:
      "નીચે દરેક પગલું પૂર્ણ કરો — અમારી ટીમ 3 કાર્યકારી દિવસોમાં તમારો સંપર્ક કરશે.",
  },
  admissionForm: {
    steps: {
      applicant: {
        label: "અરજદારની માહિતી",
        shortLabel: "અરજદાર",
        eyebrow: "પગલું 1",
        subtitle: "આ ફોર્મ સબમિટ કરનાર વ્યક્તિ વિશે",
      },
      elder: {
        label: "વડીલની માહિતી",
        shortLabel: "વડીલ",
        eyebrow: "પગલું 2",
        subtitle: "ભલામણ કરાયેલ વૃદ્ધ વ્યક્તિ વિશે",
      },
      income: {
        label: "આવકની માહિતી",
        shortLabel: "આવક",
        eyebrow: "પગલું 3",
        subtitle: "પાત્રતા અને સેવા શ્રેણીનું મૂલ્યાંકન કરવામાં મદદ કરે છે",
      },
      contacts: {
        label: "સંપર્ક વ્યક્તિઓ",
        shortLabel: "સંપર્કો",
        eyebrow: "પગલું 4",
        subtitle: "ઓછામાં ઓછો એક સ્થાનિક સંપર્ક, પ્રાધાન્યમાં ત્રણ",
      },
      family: {
        label: "કુટુંબની વિગતો અને ટિપ્પણીઓ",
        shortLabel: "કુટુંબ",
        eyebrow: "પગલું 5",
        subtitle: "સમીક્ષા પહેલાં કુટુંબના સભ્યો અને કોઈપણ વધારાની નોંધ ઉમેરો",
      },
    },
    fields: {
      applicantName: {
        label: "અરજદારનું નામ",
        placeholder: "તમારું પૂરું નામ",
      },
      mobile: {
        label: "મોબાઇલ નંબર",
        placeholder: "+91 …",
      },
      address: {
        label: "સરનામું",
        placeholder: "શેરી, શહેર, જિલ્લો, રાજ્ય, પિનકોડ",
      },
      relationship: {
        label: "વડીલ સાથેનો સંબંધ",
        placeholder: "સંબંધ પસંદ કરો...",
        searchPlaceholder: "સંબંધ શોધો...",
        emptyText: "કોઈ સંબંધ મળ્યો નથી.",
      },
      elderName: {
        label: "વડીલનું નામ",
        placeholder: "પૂરું નામ",
      },
      fatherName: {
        label: "પિતાનું નામ",
        placeholder: "પિતાનું નામ",
      },
      age: {
        label: "ઉંમર",
        placeholder: "દા.ત. 72",
      },
      district: {
        label: "જિલ્લો",
        placeholder: "જિલ્લો પસંદ કરો...",
        searchPlaceholder: "જિલ્લો શોધો...",
        emptyText: "કોઈ જિલ્લો મળ્યો નથી.",
      },
      city: {
        label: "શહેર",
        searchPlaceholder: "શહેર શોધો...",
        emptyDisabled: "પહેલા જિલ્લો પસંદ કરો.",
        empty: "કોઈ શહેર મળ્યું નથી.",
      },
      area: {
        label: "વિસ્તાર",
        searchPlaceholder: "વિસ્તાર શોધો...",
        emptyDisabled: "પહેલા શહેર પસંદ કરો.",
        empty: "કોઈ વિસ્તાર મળ્યો નથી.",
      },
      currentLivingSituation: {
        label: "વર્તમાન રહેઠાણની સ્થિતિ",
        placeholder: "વડીલ હાલમાં ક્યાં અને કોની સાથે રહે છે",
      },
      physicalCondition: {
        label: "શારીરિક સ્થિતિ",
        placeholder: "હલનચલન, લાંબા ગાળાની બીમારીઓ, દૈનિક સહાયની જરૂરિયાત",
      },
      reasonForAdmission: {
        label: "પ્રવેશનું કારણ",
        placeholder: "પ્રવેશની વિનંતી કેમ કરવામાં આવી રહી છે?",
      },
      pensionDetails: {
        label: "પેન્શનની વિગતો",
        placeholder: "દા.ત. ₹2,500 / મહિને રાજ્ય પેન્શન",
      },
      otherIncome: {
        label: "અન્ય આવક",
        placeholder: "ભાડું, કુટુંબ તરફથી મદદ, વગેરે.",
      },
      contact1: {
        label: "સંપર્ક વ્યક્તિ 1 (નામ + મોબાઇલ)",
        placeholder: "દા.ત. રમેશ પટેલ — +91 …",
      },
      contact2: {
        label: "સંપર્ક વ્યક્તિ 2 (નામ + મોબાઇલ)",
        placeholder: "દા.ત. સીતા બેન — +91 …",
      },
      contact3: {
        label: "સંપર્ક વ્યક્તિ 3 (નામ + મોબાઇલ)",
        placeholder: "વૈકલ્પિક",
      },
      additionalRemarks: {
        label: "વધારાની ટિપ્પણીઓ",
        placeholder:
          "ખાસ જરૂરિયાતો, ભાષા, આહાર સંબંધી નોંધ, ધાર્મિક બાબતો…",
      },
    },
    consent:
      "સબમિટ કરીને, તમે પુષ્ટિ કરો છો કે શેર કરેલી માહિતી તમારી શ્રેષ્ઠ જાણકારી મુજબ સચોટ છે. અમારી ટીમ તમારી અરજીની સમીક્ષા કરશે અને 3 કાર્યકારી દિવસોમાં તમારો સંપર્ક કરશે.",
    nav: {
      previous: "પાછળ",
      next: "આગળ",
      remainingOne: "{{count}} પગલું બાકી",
      remainingOther: "{{count}} પગલાં બાકી",
    },
    submit: {
      saving: "સાચવી રહ્યું છે…",
      update: "અરજી અપડેટ કરો",
      save: "અરજી સાચવો",
      submit: "અરજી સબમિટ કરો",
    },
    toast: {
      updated: "પ્રવેશ અરજી સફળતાપૂર્વક અપડેટ થઈ.",
      saved: "પ્રવેશ અરજી સફળતાપૂર્વક સાચવાઈ.",
      updateFailed: "અરજી અપડેટ કરવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
      submitFailed: "અરજી સબમિટ કરવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    },
    location: {
      cityPlaceholderDisabled: "પહેલાં જિલ્લો પસંદ કરો",
      cityPlaceholder: "શહેર પસંદ કરો...",
      areaPlaceholderDisabled: "પહેલાં શહેર પસંદ કરો",
      areaPlaceholder: "વિસ્તાર પસંદ કરો...",
    },
    validation: {
      applicantNameRequired: "અરજદારનું નામ જરૂરી છે.",
      applicantMobileRequired: "અરજદારનો મોબાઇલ નંબર જરૂરી છે.",
      applicantMobileInvalid:
        "પસંદ કરેલા દેશ માટે માન્ય મોબાઇલ નંબર દાખલ કરો.",
      applicantAddressRequired: "અરજદારનું સરનામું જરૂરી છે.",
      relationshipRequired: "વડીલ સાથેનો સંબંધ જરૂરી છે.",
      elderNameRequired: "વડીલનું નામ જરૂરી છે.",
      ageRequired: "વડીલની માન્ય ઉંમર જરૂરી છે.",
      districtRequired: "જિલ્લો જરૂરી છે.",
      cityRequired: "શહેર જરૂરી છે.",
      areaRequired: "વિસ્તાર જરૂરી છે.",
      reasonRequired: "પ્રવેશનું કારણ જરૂરી છે.",
      emergencyContactRequired: "ઓછામાં ઓછો એક કટોકટી સંપર્ક જરૂરી છે.",
    },
  },
  admissionInquiry: {
    eyebrow: "પ્રવેશ",
    title: "પ્રવેશ પૂછપરછ ફોર્મ",
    subtitle:
      "વડીલની આરોગ્ય, આવક અને પરિવારની વિગતો શેર કરો — અમારી સંભાળ ટીમ સમીક્ષા કરીને 3 કાર્યકારી દિવસોમાં તમારો સંપર્ક કરશે.",
  },
  visitorForm: {
    eyebrow: "મુલાકાતી પ્રતિભાવ",
    title: "મુલાકાતી પ્રતિભાવ ફોર્મ",
    subtitle:
      "તમારી મુલાકાતની વિગતો, પરિવારની માહિતી અને પ્રતિભાવ શેર કરો — અમારી ટીમ સમીક્ષા કરીને જીવનધારા પર તમારું સ્વાગત કરશે.",
    submit: "મુલાકાત પ્રતિભાવ સબમિટ કરો",
    submitting: "સબમિટ થઈ રહ્યું છે…",
    reset: "ફોર્મ રીસેટ કરો",
    toast: {
      success: "મુલાકાત પ્રતિભાવ સફળતાપૂર્વક સબમિટ થયો.",
      error: "મુલાકાત પ્રતિભાવ સબમિટ થઈ શક્યો નથી. કૃપા કરીને ફરી પ્રયાસ કરો.",
    },
    validation: {
      dateRequired: "કૃપા કરીને મુલાકાતની તારીખ પસંદ કરો.",
      nameRequired: "કૃપા કરીને મુલાકાતીનું નામ દાખલ કરો.",
      mobileInvalid: "પસંદ કરેલા દેશ માટે માન્ય મોબાઇલ નંબર દાખલ કરો.",
      residencePhoneInvalid: "માન્ય રહેઠાણ ફોન નંબર દાખલ કરો.",
      emailInvalid: "માન્ય ઈમેઇલ સરનામું દાખલ કરો.",
      ageInvalid: "1 થી 120 વચ્ચે માન્ય ઉંમર દાખલ કરો.",
      referrerMobileInvalid:
        "પસંદ કરેલા દેશ માટે માન્ય રેફરર મોબાઇલ નંબર દાખલ કરો.",
      familyNameRequired:
        "સંબંધ સાથેના દરેક પરિવાર સભ્યનું નામ જરૂરી છે.",
      familyRelationshipRequired:
        "નામ સાથેના દરેક પરિવાર સભ્યનો સંબંધ જરૂરી છે.",
    },
  },
  visitorInquiryForm: {
    eyebrow: "મુલાકાત પૂછપરછ",
    title: "મુલાકાત પૂછપરછ ફોર્મ",
    subtitle:
      "મુલાકાતની યોજના છે? મુલાકાત વિગતો, કારણ અને સંદર્ભ શેર કરો — અમારી ટીમ જીવનધારા વૃદ્ધાશ્રમ પર તમારું સ્વાગત કરશે.",
    submit: "મુલાકાત પૂછપરછ સબમિટ કરો",
    submitting: "સબમિટ થઈ રહ્યું છે…",
    reset: "ફોર્મ રીસેટ કરો",
    toast: {
      success: "મુલાકાત પૂછપરછ સફળતાપૂર્વક સબમિટ થઈ.",
      error: "મુલાકાત પૂછપરછ સબમિટ થઈ શકી નથી. કૃપા કરીને ફરી પ્રયાસ કરો.",
    },
    validation: {
      dateRequired: "કૃપા કરીને મુલાકાતની તારીખ પસંદ કરો.",
      nameRequired: "કૃપા કરીને મુલાકાતીનું નામ દાખલ કરો.",
      mobileInvalid: "પસંદ કરેલા દેશ માટે માન્ય મોબાઇલ નંબર દાખલ કરો.",
      residencePhoneInvalid: "માન્ય રહેઠાણ ફોન નંબર દાખલ કરો.",
      emailInvalid: "માન્ય ઈમેઇલ સરનામું દાખલ કરો.",
      ageInvalid: "1 થી 120 વચ્ચે માન્ય ઉંમર દાખલ કરો.",
      referrerMobileInvalid:
        "પસંદ કરેલા દેશ માટે માન્ય રેફરર મોબાઇલ નંબર દાખલ કરો.",
      familyNameRequired:
        "સંબંધ સાથેના દરેક પરિવાર સભ્યનું નામ જરૂરી છે.",
      familyRelationshipRequired:
        "નામ સાથેના દરેક પરિવાર સભ્યનો સંબંધ જરૂરી છે.",
    },
  },
  visitorFields: {
    sections: {
      visitDetails: "મુલાકાત વિગતો",
      reasonForVisit: "મુલાકાતનું કારણ",
      reference: "સંદર્ભ",
      familySummary: "પરિવાર સારાંશ",
      familyMembers: "પરિવારના સભ્યો",
      feedback: "પ્રતિભાવ",
    },
    labels: {
      visitDate: "મુલાકાતની તારીખ",
      visitorName: "મુલાકાતીનું નામ",
      dateOfBirth: "જન્મ તારીખ",
      age: "ઉંમર",
      agePlaceholder: "જન્મ તારીખથી આપમેળે ગણતરી કરેલ",
      marriedStatus: "લગ્ન સ્થિતિ",
      marriedStatusPlaceholder: "લગ્ન સ્થિતિ પસંદ કરો...",
      unmarriedOrSingle: "અપરણિત / એકલ",
      married: "પરણિત",
      marriageAnniversaryDate: "લગ્ન વર્ષગાંઠની તારીખ",
      occupation: "વ્યવસાય",
      mobileNumber: "મોબાઇલ નંબર",
      residencePhone: "રહેઠાણ ફોન",
      email: "ઈમેઇલ",
      address: "સરનામું",
      businessAddress: "વ્યવસાયનું સરનામું",
      reasonForVisit: "મુલાકાતનું કારણ",
      visitedBefore: "અગાઉ મુલાકાત લીધી છે",
      visitedBeforeHelp: "શું આ મુલાકાતી અગાઉ પણ અહીં આવ્યા છે?",
      previousVisitDetails: "અગાઉની મુલાકાત વિગતો",
      referenceSource: "સંદર્ભ સ્ત્રોત",
      selectSourcePlaceholder: "સ્ત્રોત પસંદ કરો...",
      referrerName: "રેફરરનું નામ",
      referrerMobile: "રેફરરનો મોબાઇલ",
      totalFamilyMembers: "કુલ પરિવાર સભ્યો",
      maleCount: "પુરુષોની સંખ્યા",
      femaleCount: "મહિલાઓની સંખ્યા",
      addFamilyMember: "પરિવારના સભ્ય ઉમેરો",
      noFamilyMembers: "હજી સુધી પરિવારના કોઈ સભ્ય ઉમેરાયા નથી.",
      srNo: "ક્રમ નં.",
      name: "નામ",
      relationship: "સંબંધ",
      selectRelationship: "સંબંધ પસંદ કરો...",
      searchRelationship: "સંબંધ શોધો...",
      noRelationshipFound: "કોઈ સંબંધ મળ્યો નથી.",
      education: "શિક્ષણ",
      feedback: "પ્રતિભાવ",
    },
    referenceSources: {
      banner: "બેનર જાહેરાત",
      friend: "મિત્ર દ્વારા",
      reference: "કોઈનો સંદર્ભ",
      other: "અન્ય",
    },
  },
  visitorSuccessDialog: {
    title: "મુલાકાત નોંધણી સબમિટ થઈ",
    description:
      "જીવનધારાની મુલાકાત નોંધાવવા બદલ આભાર. તમારી વિગતો અમારી ટીમને મળી ગઈ છે.",
    visitor: "મુલાકાતી",
    whatHappensNext: "આગળ શું થશે",
    step1: "અમારી ટીમ તમે શેર કરેલી મુલાકાત વિગતોની સમીક્ષા કરશે.",
    contactBefore: "જરૂર પડે તો અમે",
    workingDays: "2 કાર્યકારી દિવસોમાં",
    contactAfter: "તમારો સંપર્ક કરીશું.",
    done: "થઈ ગયું",
    backToHome: "હોમ પર પાછા જાઓ",
  },
  inquiryForm: {
    steps: {
      inquiry: {
        label: "પૂછપરછની વિગતો",
        shortLabel: "પૂછપરછ",
        eyebrow: "પગલું 1",
        subtitle: "આ પૂછપરછ કરનાર વ્યક્તિ વિશે",
      },
      family: {
        label: "પરિવારના સભ્યો",
        shortLabel: "પરિવાર",
        eyebrow: "પગલું 2",
        subtitle: "પરિવારના સભ્યોની સંપર્ક વિગતો ઉમેરો",
      },
      elder: {
        label: "વડીલની વિગતો",
        shortLabel: "વડીલ",
        eyebrow: "પગલું 3",
        subtitle: "ભલામણ કરાયેલ વૃદ્ધ વ્યક્તિ વિશે",
      },
      income: {
        label: "આવક અને નાણાકીય સહાયક",
        shortLabel: "આવક",
        eyebrow: "પગલું 4",
        subtitle: "આવકના સ્ત્રોત અને અન્ય નાણાકીય સહાયકની વિગતો",
      },
      health: {
        label: "આરોગ્ય સ્થિતિ",
        shortLabel: "આરોગ્ય",
        eyebrow: "પગલું 5",
        subtitle: "વિકલાંગતા, બીમારીઓ અને એલર્જી",
      },
      treatment: {
        label: "વર્તમાન સારવાર",
        shortLabel: "સારવાર",
        eyebrow: "પગલું 6",
        subtitle: "ચાલુ સારવાર અને દવાઓ",
      },
      operation: {
        label: "ઓપરેશન ઇતિહાસ",
        shortLabel: "ઓપરેશન",
        eyebrow: "પગલું 7",
        subtitle: "ભૂતકાળના ઓપરેશન અને રિકવરી દવા",
      },
      notes: {
        label: "વધારાની નોંધ",
        shortLabel: "નોંધ",
        eyebrow: "પગલું 8",
        subtitle: "અમારી ટીમ માટે કોઈપણ વધારાની માહિતી શેર કરો",
      },
    },
    fields: {
      applicationDate: {
        label: "અરજીની તારીખ",
      },
      inquirerName: {
        label: "પૂછપરછ કરનારનું નામ",
        placeholder: "પૂછપરછ કરનાર વ્યક્તિનું પૂરું નામ",
      },
      inquirerMobile: {
        label: "પૂછપરછ કરનારનો મોબાઇલ",
        placeholder: "10-અંકનો મોબાઇલ નંબર",
      },
      inquirerEmail: {
        label: "પૂછપરછ કરનારનો ઇમેઇલ",
        placeholder: "ઇમેઇલ સરનામું",
      },
      referencePersonName: {
        label: "સંદર્ભ વ્યક્તિનું નામ",
        placeholder: "સંદર્ભ વ્યક્તિનું પૂરું નામ",
      },
      referencePersonMobile: {
        label: "સંદર્ભ વ્યક્તિનો મોબાઇલ નંબર",
        placeholder: "10-અંકનો મોબાઇલ નંબર",
      },
      district: {
        label: "જિલ્લો",
        placeholder: "જિલ્લો પસંદ કરો...",
        searchPlaceholder: "જિલ્લો શોધો...",
        emptyText: "કોઈ જિલ્લો મળ્યો નહીં.",
      },
      city: {
        label: "શહેર",
        searchPlaceholder: "શહેર શોધો...",
        emptyDisabled: "પહેલા જિલ્લો પસંદ કરો.",
        empty: "કોઈ શહેર મળ્યું નહીં.",
      },
      area: {
        label: "વિસ્તાર",
        searchPlaceholder: "વિસ્તાર શોધો...",
        emptyDisabled: "પહેલા શહેર પસંદ કરો.",
        empty: "કોઈ વિસ્તાર મળ્યો નહીં.",
      },
      pincode: {
        label: "પિનકોડ",
        placeholder: "6-અંકનો પિનકોડ",
      },
      landmark: {
        label: "લેન્ડમાર્ક",
        placeholder: "દા.ત. શાંતિ નગર બસ સ્ટોપ પાસે",
      },
      elderName: {
        label: "વડીલનું નામ",
        placeholder: "વડીલનું પૂરું નામ",
      },
      elderWeight: {
        label: "વડીલનું વજન",
        placeholder: "વજન કિલોમાં (દા.ત. 65)",
      },
      sameAsInquirerAddress: {
        label: "પિતા-માતા જેવું જ સરનામું",
      },
      elderDistrict: {
        label: "વડીલનો જિલ્લો",
        placeholder: "જિલ્લો પસંદ કરો...",
        searchPlaceholder: "જિલ્લો શોધો...",
        emptyText: "કોઈ જિલ્લો મળ્યો નહીં.",
      },
      elderCity: {
        label: "વડીલનું શહેર",
        searchPlaceholder: "શહેર શોધો...",
        emptyDisabled: "પહેલા જિલ્લો પસંદ કરો.",
        empty: "કોઈ શહેર મળ્યું નહીં.",
      },
      elderArea: {
        label: "વડીલનો વિસ્તાર",
        searchPlaceholder: "વિસ્તાર શોધો...",
        emptyDisabled: "પહેલા શહેર પસંદ કરો.",
        empty: "કોઈ વિસ્તાર મળ્યો નહીં.",
      },
      elderPincode: {
        label: "વડીલનો પિનકોડ",
        placeholder: "6-અંકનો પિનકોડ",
      },
      elderLandmark: {
        label: "વડીલનું લેન્ડમાર્ક",
        placeholder: "દા.ત. મણિનગર રેલવે સ્ટેશનની સામે",
      },
      physicalHealthStatus: {
        label: "શારીરિક આરોગ્ય સ્થિતિ",
        placeholder: "સામાન્ય હલનચલન અને શારીરિક સ્થિતિ",
      },
      reasonForAdmission: {
        label: "પ્રવેશનું કારણ",
        placeholder: "પ્રવેશની વિનંતી કેમ કરવામાં આવી રહી છે?",
      },
      pensionAmount: {
        label: "પેન્શન રકમ",
        placeholder: "દા.ત. 8500.00",
      },
      otherIncome: {
        label: "અન્ય આવક",
        placeholder: "દા.ત. 2000.00",
      },
      otherFinancierName: {
        label: "અન્ય નાણાકીય સહાયકનું નામ",
        placeholder: "દા.ત. રાજેશ શાહ",
      },
      otherFinancierNumber: {
        label: "અન્ય નાણાકીય સહાયકનો નંબર",
        placeholder: "દા.ત. 9876543210",
      },
      otherFinancierEmail: {
        label: "અન્ય નાણાકીય સહાયકનો ઈમેલ",
        placeholder: "દા.ત. rajesh@example.com",
      },
      hasPhysicalDisability: {
        label: "શારીરિક વિકલાંગતા છે?",
      },
      physicalDisabilityDetails: {
        label: "શારીરિક વિકલાંગતાની વિગતો",
        placeholder: "દા.ત. જમણા ઘૂંટણમાં મર્યાદિત હલનચલન.",
      },
      hasMentalHealthIssue: {
        label: "માનસિક સ્વાસ્થ્યને લગતી અગાઉની કે વર્તમાન સમસ્યા છે?",
      },
      mentalHealthIssueDetails: {
        label: "માનસિક આરોગ્ય સમસ્યાની વિગતો",
        placeholder: "સ્થિતિનું વર્ણન કરો",
      },
      hasExistingDisease: {
        label: "કોઈ હાલની બીમારી છે?",
      },
      diseaseDetails: {
        label: "બીમારીની વિગતો",
        placeholder: "દા.ત. હાઈ બ્લડ પ્રેશર",
      },
      hasFoodAllergy: {
        label: "ખોરાકની એલર્જી છે?",
      },
      foodAllergyDetails: {
        label: "ખોરાક એલર્જીની વિગતો",
        placeholder: "ખોરાકની એલર્જીનું વર્ણન કરો",
      },
      hasMedicineAllergy: {
        label: "દવાની એલર્જી છે?",
      },
      medicineAllergyDetails: {
        label: "દવા એલર્જીની વિગતો",
        placeholder: "દા.ત. પેનિસિલિનની એલર્જી છે.",
      },
      specialMedicalInstructions: {
        label: "ખાસ તબીબી સૂચનાઓ",
        placeholder: "દા.ત. ઓછા-મીઠાનો આહાર, રોજ BP તપાસો.",
      },
      currentlyUnderTreatment: {
        label: "હાલમાં સારવાર હેઠળ છે?",
      },
      currentDoctorName: {
        label: "વર્તમાન ડૉક્ટરનું નામ",
        placeholder: "દા.ત. ડૉ. મેહુલ શાહ",
      },
      currentHospitalName: {
        label: "વર્તમાન હૉસ્પિટલનું નામ",
        placeholder: "દા.ત. એપોલો હૉસ્પિટલ",
      },
      currentHospitalAddress: {
        label: "વર્તમાન હૉસ્પિટલનું સરનામું",
        placeholder: "દા.ત. ભાટ, ગાંધીનગર",
      },
      takesCurrentMedicines: {
        label: "હાલમાં દવાઓ લે છે?",
      },
      medicines: {
        label: "વર્તમાન દવાઓ",
        addMedicine: "દવા ઉમેરો",
        medicine: "દવા",
        remove: "દવા દૂર કરો",
        treatmentName: "સારવારનું નામ",
        treatmentNamePlaceholder: "દા.ત. બ્લડ પ્રેશર નિયંત્રણ",
        treatmentSearchPlaceholder: "સારવાર શોધો...",
        treatmentEmpty: "કોઈ સારવાર મળી નહીં.",
        treatmentOther: "અન્ય (જાતે દાખલ કરો)",
        treatmentBackToList: "તેના બદલે યાદીમાંથી પસંદ કરો",
        name: "દવાનું નામ",
        namePlaceholder: "દા.ત. એમ્લોડિપિન",
        dosage: "ડોઝ",
        dosagePlaceholder: "દા.ત. 5mg",
        frequency: "આવર્તન",
        frequencyPlaceholder: "દા.ત. દિવસમાં એક વાર",
      },
      hadOperationBefore: {
        label: "પહેલાં ઓપરેશન થયું છે?",
      },
      operations: {
        label: "ઓપરેશન",
        addOperation: "ઓપરેશન ઉમેરો",
        operation: "ઓપરેશન",
        remove: "ઓપરેશન દૂર કરો",
        type: "ઓપરેશનનો પ્રકાર",
        typePlaceholder: "દા.ત. મોતિયાનું ઓપરેશન",
        date: "ઓપરેશનની તારીખ",
        doctorName: "ઓપરેશન ડૉક્ટરનું નામ",
        doctorNamePlaceholder: "દા.ત. ડૉ. અનિતા દેસાઈ",
        hospitalName: "ઓપરેશન હૉસ્પિટલનું નામ",
        hospitalNamePlaceholder: "દા.ત. નેત્ર આઈ કેર",
        district: {
          label: "હોસ્પિટલ જિલ્લો",
          placeholder: "જિલ્લો પસંદ કરો...",
          searchPlaceholder: "જિલ્લો શોધો...",
          emptyText: "કોઈ જિલ્લો મળ્યો નહીં.",
        },
        city: {
          label: "હોસ્પિટલ શહેર",
          placeholder: "શહેર પસંદ કરો...",
          searchPlaceholder: "શહેર શોધો...",
          emptyDisabled: "પહેલા જિલ્લો પસંદ કરો.",
          empty: "કોઈ શહેર મળ્યું નહીં.",
        },
        area: {
          label: "હોસ્પિટલ વિસ્તાર",
          placeholder: "વિસ્તાર પસંદ કરો...",
          searchPlaceholder: "વિસ્તાર શોધો...",
          emptyDisabled: "પહેલા શહેર પસંદ કરો.",
          empty: "કોઈ વિસ્તાર મળ્યો નહીં.",
        },
        details: "ઓપરેશનની વિગતો",
        detailsPlaceholder: "પરિણામ અને રિકવરી નોંધ",
        takesRecoveryMedicine: "રિકવરી દવા લે છે?",
        recoveryMedicineDetails: "રિકવરી દવાની વિગતો",
        recoveryMedicineDetailsPlaceholder:
          "દા.ત. 2 અઠવાડિયા માટે એન્ટિબાયોટિક આઇ ડ્રોપ્સ.",
      },
      additionalNotes: {
        label: "વધારાની નોંધ",
        placeholder: "દા.ત. શાકાહારી જૈન ભોજન પસંદ કરે છે.",
      },
      familyMembers: {
        label: "પરિવારના સભ્યો",
        addMember: "સભ્ય ઉમેરો",
        member: "સભ્ય",
        remove: "સભ્ય દૂર કરો",
        name: "નામ",
        namePlaceholder: "પરિવારના સભ્યનું નામ",
        relationship: "સંબંધ",
        relationshipPlaceholder: "સંબંધ પસંદ કરો...",
        relationshipSearch: "સંબંધ શોધો...",
        relationshipEmpty: "કોઈ સંબંધ મળ્યો નથી.",
        relationshipOther: "અન્ય (જાતે દાખલ કરો)",
        relationshipCustomPlaceholder: "સંબંધનું નામ દાખલ કરો",
        relationshipBackToList: "યાદીમાંથી પસંદ કરો",
        mobile: "મોબાઇલ",
        mobilePlaceholder: "મોબાઇલ નંબર",
        details: "વિગતો",
        detailsPlaceholder: "દા.ત. અમદાવાદમાં રહે છે, મુખ્ય સંપર્ક.",
      },
    },
    consent:
      "સબમિટ કરીને, તમે પુષ્ટિ કરો છો કે શેર કરેલી માહિતી તમારી શ્રેષ્ઠ જાણકારી મુજબ સચોટ છે. અમારી ટીમ તમારી પૂછપરછની સમીક્ષા કરશે અને 3 કાર્યકારી દિવસોમાં તમારો સંપર્ક કરશે.",
    nav: {
      previous: "પાછળ",
      next: "આગળ",
      remainingOne: "{{count}} પગલું બાકી",
      remainingOther: "{{count}} પગલાં બાકી",
    },
    submit: {
      saving: "સાચવી રહ્યું છે…",
      update: "પૂછપરછ અપડેટ કરો",
      save: "પૂછપરછ સાચવો",
      submit: "પૂછપરછ સબમિટ કરો",
    },
    confirmDialog: {
      title: "તમારી સબમિશનની પુષ્ટિ કરો",
      description:
        "તમારી પ્રવેશ પૂછપરછ સબમિટ કરતા પહેલા કૃપા કરીને નીચેની વિગતોની સમીક્ષા કરો. જરૂર હોય તો તમે ફેરફાર કરવા પાછા જઈ શકો છો.",
      inquirer: "પૂછપરછ કરનાર",
      elder: "વડીલ",
      applicationDate: "અરજીની તારીખ",
      consentNote:
        "સબમિટ કરીને, તમે પુષ્ટિ કરો છો કે શેર કરેલી માહિતી તમારી શ્રેષ્ઠ જાણકારી મુજબ સચોટ છે. અમારી ટીમ તમારી પૂછપરછની સમીક્ષા કરશે અને 3 કાર્યકારી દિવસોમાં તમારો સંપર્ક કરશે.",
      goBack: "પાછા જાઓ અને ફેરફાર કરો",
      confirmSubmit: "પુષ્ટિ કરો અને સબમિટ કરો",
      submitting: "સબમિટ કરી રહ્યું છે…",
    },
    toast: {
      updated: "પ્રવેશ પૂછપરછ સફળતાપૂર્વક અપડેટ થઈ.",
      saved: "પ્રવેશ પૂછપરછ સફળતાપૂર્વક સાચવાઈ.",
      updateFailed: "પૂછપરછ અપડેટ કરવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
      submitFailed: "પૂછપરછ સબમિટ કરવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    },
    validation: {
      applicationDateRequired: "અરજીની તારીખ જરૂરી છે.",
      inquirerNameRequired: "પૂછપરછ કરનારનું નામ જરૂરી છે.",
      inquirerMobileRequired: "પૂછપરછ કરનારનો મોબાઇલ નંબર જરૂરી છે.",
      inquirerMobileInvalid:
        "પસંદ કરેલા દેશ માટે માન્ય મોબાઇલ નંબર દાખલ કરો.",
      inquirerEmailRequired: "પૂછપરછ કરનારનો ઇમેઇલ જરૂરી છે.",
      inquirerEmailInvalid: "માન્ય ઇમેઇલ સરનામું દાખલ કરો.",
      referencePersonMobileInvalid:
        "પસંદ કરેલા દેશ માટે માન્ય સંદર્ભ વ્યક્તિનો મોબાઇલ નંબર દાખલ કરો.",
      districtRequired: "જિલ્લો જરૂરી છે.",
      cityRequired: "શહેર જરૂરી છે.",
      areaRequired: "વિસ્તાર જરૂરી છે.",
      pincodeRequired: "માન્ય 6-અંકનો પિનકોડ જરૂરી છે.",
      elderNameRequired: "વડીલનું નામ જરૂરી છે.",
      elderWeightInvalid: "1 થી 500 કિલો વચ્ચે માન્ય વડીલનું વજન દાખલ કરો.",
      elderDistrictRequired: "વડીલનો જિલ્લો જરૂરી છે.",
      elderCityRequired: "વડીલનું શહેર જરૂરી છે.",
      elderAreaRequired: "વડીલનો વિસ્તાર જરૂરી છે.",
      elderPincodeRequired: "માન્ય 6-અંકનો વડીલનો પિનકોડ જરૂરી છે.",
      reasonRequired: "પ્રવેશનું કારણ જરૂરી છે.",
      otherIncomeRequired: "અન્ય આવક જરૂરી છે.",
      familyMemberNameRequired: "પરિવારના સભ્ય {{number}} નું નામ જરૂરી છે.",
      familyMemberRelationshipRequired:
        "પરિવારના સભ્ય {{number}} નો સંબંધ જરૂરી છે.",
      familyMemberMobileRequired:
        "પરિવારના સભ્ય {{number}} નો મોબાઇલ નંબર જરૂરી છે.",
      familyMemberMobileInvalid:
        "પરિવારના સભ્ય {{number}} માટે પસંદ કરેલા દેશનો માન્ય મોબાઇલ નંબર દાખલ કરો.",
      familyMemberDetailsRequired:
        "પરિવારના સભ્ય {{number}} ની વિગતો જરૂરી છે.",
    },
  },
  successDialog: {
    title: "અરજી સફળતાપૂર્વક સબમિટ થઈ",
    description:
      "જીવનધારા ખાતે પ્રવેશ માટે અરજી કરવા બદલ આભાર. તમારી અરજી પ્રાપ્ત થઈ ગઈ છે અને હવે અમારી સંભાળ ટીમ દ્વારા તેની સમીક્ષા થઈ રહી છે.",
    applicant: "અરજદાર",
    elder: "વડીલ",
    whatHappensNext: "હવે શું થશે",
    step1: "અમારી ટીમ તમે શેર કરેલી વિગતોની કાળજીપૂર્વક સમીક્ષા કરશે.",
    contactBefore: "અમે તમારો સંપર્ક કરીશું",
    workingDays: "3 કાર્યકારી દિવસોમાં",
    contactAfter: "આપેલા મોબાઇલ નંબર પર.",
    done: "પૂર્ણ",
    backToHome: "હોમ પર પાછા જાઓ",
  },
  formStepper: {},
};

export default account;
